import { qs, add, remove, toggle } from '@fluorescent/dom';

const selectors = {
  counterContainer: '[data-inventory-counter]',
  inventoryMessage: '.inventory-counter__message',
  countdownBar: '.inventory-counter__bar',
  progressBar: '.inventory-counter__bar-progress',
};

const classes = {
  active: 'active',
  inventoryLow: 'inventory--low',
};

const inventoryCounter = (container, config) => {
  const variantsInventories = config.variantsInventories;
  const counterContainer = qs(selectors.counterContainer, container);
  const inventoryMessageElement = qs(selectors.inventoryMessage, container);
  const progressBar = qs(selectors.progressBar, container);
  const { lowInventoryThreshold, stockCountdownMax } = counterContainer.dataset;

  // If the threshold or countdownmax contains anything but numbers abort
  if (
    !lowInventoryThreshold.match(/^[0-9]+$/) ||
    !stockCountdownMax.match(/^[0-9]+$/)
  ) {
    return;
  }

  const threshold = parseInt(lowInventoryThreshold, 10);
  const countDownMax = parseInt(stockCountdownMax, 10);

  toggle(
    counterContainer,
    classes.active,
    productIventoryValid(variantsInventories[config.id])
  );

  checkThreshold(variantsInventories[config.id]);
  setProgressBar(variantsInventories[config.id].inventory_quantity);
  setInventoryMessage(variantsInventories[config.id].inventory_message);

  function checkThreshold({
    inventory_policy,
    inventory_quantity,
    inventory_management,
  }) {
    remove(counterContainer, classes.inventoryLow);

    if (inventory_management !== null && inventory_policy === 'deny') {
      if (inventory_quantity <= threshold) {
        add(counterContainer, classes.inventoryLow);
      }
    }
  }

  function setProgressBar(inventoryQuantity) {
    if (inventoryQuantity <= 0) {
      progressBar.style.width = `${0}%`;
      return;
    }

    const progressValue =
      inventoryQuantity < countDownMax
        ? (inventoryQuantity / countDownMax) * 100
        : 100;

    progressBar.style.width = `calc(${progressValue}% + 2px)`;
  }

  function setInventoryMessage(message) {
    inventoryMessageElement.innerText = message;
  }

  function productIventoryValid(product) {
    return product.inventory_message && product.inventory_policy === 'deny';
  }

  const update = variant => {
    toggle(
      counterContainer,
      classes.active,
      variant && productIventoryValid(variantsInventories[variant.id])
    );

    if (!variant) return;
    checkThreshold(variantsInventories[variant.id]);
    setProgressBar(variantsInventories[variant.id].inventory_quantity);
    setInventoryMessage(variantsInventories[variant.id].inventory_message);
  };

  return { update };
};

export default inventoryCounter;
